import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';

const heroTexts = [
  {
    title: 'Підкорюй',
    highlight: 'нові вершини',
    description: 'Приєднуйся до спільноти скелелазів та розвивай свої навички',
  },
  {
    title: 'Досягай',
    highlight: 'своїх цілей',
    description: 'Професійні тренери та сучасне обладнання для твого прогресу',
  },
  {
    title: 'Відчуй',
    highlight: 'адреналін',
    description:
      'Випробуй себе на маршрутах різної складності та стань сильнішим',
  },
];

export const AnimatedHeroText = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % heroTexts.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const currentText = heroTexts[currentIndex];

  return (
    <div className="relative h-45 md:h-50">
      <AnimatePresence mode="wait">
        <motion.div
          key={currentIndex}
          className="space-y-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
        >
          <h1 className="text-foreground text-4xl leading-tight font-bold text-balance lg:text-5xl">
            <motion.span
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              {currentText.title}{' '}
            </motion.span>
            <motion.span
              className="text-primary block"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              {currentText.highlight}
            </motion.span>
          </h1>
          <motion.p
            className="text-muted-foreground max-w-md text-lg text-pretty"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            {currentText.description}
          </motion.p>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};
